import React from 'react';
import * as S from './styles';

const ContentWrapper = (props = {}) => {
  const { display = 'flex' } = props;
  return (
    <S.Wrapper display={display}>
      {React.Children.map(props.children, (child, idx) =>
        React.cloneElement(child, {
          order: idx + 1,
        }),
      )}
    </S.Wrapper>
  );
};

export default ContentWrapper;
